// import * as React from "react";
import { useTheme } from '@emotion/react';
import { CircleRounded } from '@mui/icons-material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, Typography, useMediaQuery } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Stack } from '@mui/system';
import { getApiCall } from 'api/apiService';
import Loading from 'assets/images/loading.png';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import { PauseIcon } from 'component/PropertyTime/PropertyTimer';
import {
  ACTIVE_CARD,
  ENDED_CARD,
  INACTIVE_CARD,
  PUBLISH_CARD,
  UNPUBLISH_CARD,
} from 'constant/app.config';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  fontsize10,
  poppins300,
  poppins400,
  poppins600,
} from 'theme/common.style';
import QuickSwitchPropertyTimer from './QuickSwitchPropertyTimer';
import { Ended, Stage1, Stage2, Stage2Final } from 'component/Common/StageTags';

function createData(
  address,
  Status,
  highestOffer,
  carbs,
  countdownTimer,
  color
) {
  return { address, Status, highestOffer, carbs, countdownTimer, color };
}

const rows = [
  createData(
    '56 Owen Street, North Bondi',
    'Online',
    '$ 1,250,000',
    'Stage 1',
    '11 : 03 :  09 : 52',
    'sucess'
  ),
  createData(
    '56 Owen Street, North Bondi',
    'Online',
    '$ 1,250,000',
    'Stage 2 - Final Offers',
    '11 : 03 :  09 : 52',
    'success'
  ),
  createData(
    '56 Owen Street, North Bondi',
    'Off Market',
    '$ 1,250,000',
    'Stage 2 - Final Offers',
    '11 : 03 :  09 : 52',
    'warning'
  ),
];

export default function QuickSwitchTable({
  isShown,
  setIsShown,
  buyerregister,
  vendor,
}) {
  const { setLoaderConfig } = useContext(LoaderContext);
  const history = useHistory();
  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);
  const dataType = userDetail?.userType;

  const [cardArray, setCardArray] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);

  const listofcards = () => {
    setIsDataFetched(true);
    setCardArray([]);
    if (vendor) {
      getApiCall(ACTIVE_CARD)
        .then(async (res) => {
          if (res?.data?.status == 1) {
            setCardArray((prevState) =>
              prevState
                ? [...prevState, ...res?.data?.propertyList]
                : res?.data?.propertyList
            );
          }
        })
        .catch((err) => {
          console.error(err);
          setCardArray([]);
        })
        .finally(() => {
          setIsDataFetched(false);
        });
      // getApiCall(INACTIVE_CARD).then(async (res) => {
      //   if (res?.data?.status == 1) {
      //     setCardArray((prevState) =>
      //       prevState
      //         ? [...prevState, ...res?.data?.propertyList]
      //         : res?.data?.propertyList
      //     );
      //     setIsDataFetched(false);
      //   }
      // });
    } else {
      getApiCall(PUBLISH_CARD)
        .then(async (res) => {
          if (res?.data?.status == 1) {
            setCardArray((prevState) =>
              prevState
                ? [...prevState, ...res?.data?.propertyList]
                : res?.data?.propertyList
            );
          }
        })
        .catch((err) => {
          console.error(err);
          setCardArray([]);
        })
        .finally(() => {
          setIsDataFetched(false);
        });
      // getApiCall(UNPUBLISH_CARD).then(async (res) => {
      //   if (res?.data?.status == 1) {
      //     setCardArray((prevState) =>
      //       prevState
      //         ? [...prevState, ...res?.data?.propertyList]
      //         : res?.data?.propertyList
      //     );
      //     setIsDataFetched(false);
      //   }
      // });
      // getApiCall(ENDED_CARD).then(async (res) => {
      //   if (res?.data?.status == 1) {
      //     setCardArray((prevState) =>
      //       prevState
      //         ? [...prevState, ...res?.data?.propertyList]
      //         : res?.data?.propertyList
      //     );
      //     setIsDataFetched(false);
      //   }
      // });
    }
  };

  useEffect(() => {
    listofcards();
  }, []);

  const onPropertyClick = (propertyId, status) => {
    if (!vendor) {
      history.push({
        pathname: `/dashboard/view-dashboard/${propertyId}`,
      });
    } else {
      if (status == 'Publish') {
        history.push({
          pathname: `/dashboard/viewactive-dashboard/${propertyId}`,
        });
      } else {
        history.push({
          pathname: `/dashboard/viewinactive-dashboard/${propertyId}`,
        });
      }
    }
  };

  // const widthProp =  window.innerWidth > 1400 ? 'yes' : window.innerWidth
  const theme = useTheme();
  const isWindowbelow1200 = useMediaQuery(theme.breakpoints.down(1200));
  const isWindowbelow800 = useMediaQuery(theme.breakpoints.down(800));
  const isWindowbelow500 = useMediaQuery(theme.breakpoints.down(500));
  const isWindowbelow400 = useMediaQuery(theme.breakpoints.down(400));

  const handleSwitch = () => {
    setIsShown(!isShown);
  };

  const [expandedRows, setExpandedRows] = useState({});

  const handleRowToggle = (propertyId) => {
    setExpandedRows((prevState) => ({
      ...prevState,
      [propertyId]: !prevState[propertyId],
    }));
  };

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (loading || isDataFetched) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '44vh',
          minWidth: '100%',
        }}
      >
        <img
          alt="Logo"
          src={Loading}
          className="loaderImage"
          style={{ height: '100px', width: '100px', margin: '0 auto' }}
        />
      </div>
    );
  }

  return (
    <>
      {cardArray?.length > 0 ? (
        // <TableContainer sx={{ marginTop: 3, height: "auto", position: "relative",width:widthProp == 'yes' ? '950px' : widthProp - 160}}>
        <TableContainer
          sx={{
            marginTop: 3,
            height: 'auto',
            position: 'relative',
            width: '100%',
          }}
        >
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="left"
                  sx={{
                    fontFamily: 'poppins',
                    fontWeight: buyerregister ? 500 : 400,
                    fontSize: buyerregister ? '16px' : '10px',
                    color: buyerregister ? '#000000' : '#666666',
                    borderBottom: 'none',
                    lineHeight: '24px',
                  }}
                >
                  Address
                </TableCell>

                {!isWindowbelow1200 && (
                  <>
                    <TableCell
                      sx={{
                        fontFamily: 'poppins',
                        fontWeight: buyerregister ? 500 : 400,
                        fontSize: buyerregister ? '16px' : '10px',
                        color: buyerregister ? '#000000' : '#666666',
                        borderBottom: 'none',
                        paddingRight: buyerregister && '30px',
                        lineHeight: '24px',
                      }}
                      align={'left'}
                    >
                      Status
                    </TableCell>
                    {!buyerregister && (
                      <>
                        <TableCell
                          align="center"
                          sx={{
                            ...poppins400,
                            ...fontsize10,
                            color: '#666666',
                            borderBottom: 'none',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          Highest Offer
                        </TableCell>
                        <TableCell
                          sx={{
                            ...poppins400,
                            ...fontsize10,
                            color: '#666666',
                            borderBottom: 'none',
                          }}
                        ></TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            ...poppins400,
                            ...fontsize10,
                            color: '#666666',
                            borderBottom: 'none',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          CountDown Timer
                        </TableCell>
                      </>
                    )}
                  </>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {cardArray
                .slice()
                .sort((a, b) => {
                  const statusOrder = {
                    Publish: 1,
                    Unpublish: 2,
                    Sold: 3,
                  };
                  return (
                    statusOrder[a.property.status] -
                    statusOrder[b.property.status]
                  );
                })
                ?.map((row) => (
                  <TableRow
                    hover
                    key={row.address}
                    onClick={() => {
                      onPropertyClick(
                        row?.property?.propertyId,
                        row?.property?.status
                      );
                      handleSwitch();
                    }}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      cursor: 'pointer',
                      borderBottom: '1px solid #ccc',
                      // whiteSpace:"nowrap"
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        width: buyerregister ? '70%' : '40%',
                        fontFamily: 'poppins',
                        fontWeight: buyerregister ? 300 : 400,
                        fontSize: buyerregister ? '16px' : '10px',
                        color: buyerregister ? '#000000' : '#666666',
                      }}
                    >
                      <Box
                        sx={{
                          width: '100%',
                          maxWidth: buyerregister ? 'auto' : 240,
                          overflow: 'hidden',
                        }}
                      >
                        {row?.propertyAddress?.streetName}
                        {/* expanded content */}
                      </Box>
                      {expandedRows[row?.property?.propertyId] &&
                        isWindowbelow1200 &&
                        (isWindowbelow800 ? (
                          <Table
                            sx={{ width: isWindowbelow400 ? '60vw' : '100%' }}
                          >
                            <TableBody>
                              <TableRow>
                                <TableCell
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '10px',
                                    color: '#666666',
                                  }}
                                >
                                  Status
                                </TableCell>
                                <TableCell>
                                  <Box
                                    // variant="contained"
                                    // bgcolor={row.Status == "Online" ? "#10D35E" : "#F39800"}

                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      width: 'min-content',
                                      padding: '2px 20px',
                                      borderRadius: '3px',
                                      whiteSpace: 'nowrap',
                                      color: '#FFFFFF',
                                      background:
                                        row?.property?.status == 'Sold'
                                          ? '#F93939'
                                          : row?.property?.status == 'Unpublish'
                                          ? '#529aee'
                                          : row.campaignType === 'Online'
                                          ? '#10D35E'
                                          : '#F39800',
                                      textTransform: 'none',
                                      fontSize: '14px',
                                      fontWeight: buyerregister ? 300 : 400,
                                      fontFamily: 'poppins',
                                    }}
                                  >
                                    {' '}
                                    {row?.property?.status == 'Sold'
                                      ? row?.property?.status
                                      : row?.property?.status == 'Unpublish'
                                      ? 'Unpublished'
                                      : row?.campaignType}
                                  </Box>
                                </TableCell>
                              </TableRow>
                              {!buyerregister && (
                                <>
                                  <TableRow>
                                    <TableCell
                                      sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '10px',
                                        color: '#666666',
                                      }}
                                    >
                                      Highest Offer
                                    </TableCell>
                                    <TableCell>
                                      {row.highestOffer &&
                                      row.highestOffer !== '0' ? (
                                        <Stack
                                          direction="row"
                                          alignItems="center"
                                          //  justifyContent="center"
                                          border={'none'}
                                          gap={1}
                                          //  width={"100%"}
                                          fontWeight={300}
                                          color={'#000000'}
                                          fontFamily={'poppins'}
                                          // marginLeft={
                                          //  row.propertyAddress.streetName.length < 10 ? 0 : 5
                                          // }
                                        >
                                          {/* <TableCell colSpan={5} style={{borderBottom:"0px"}}> */}
                                          {row.highestOffer}
                                          <CircleRounded
                                            // color={data.color}
                                            sx={{
                                              fontSize: '7px',
                                              marginBottom: '15px',
                                              color:
                                                row?.highestOfferIsConditional ==
                                                1
                                                  ? '#F93939'
                                                  : '#10D35E',
                                            }}
                                          />
                                          {/* </TableCell> */}
                                        </Stack>
                                      ) : (
                                        <Typography>-</Typography>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell
                                      sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '10px',
                                        color: '#666666',
                                      }}
                                    >
                                      Stage
                                    </TableCell>
                                    <TableCell>
                                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {row?.timerStatus === 'End' ? (
                                          <Ended matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px' }} />
                                        ) : row?.stage === 'ST1' ? (
                                          <Stage1 matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px' }} />
                                        ) : row?.stage === 'ST2' && row?.isReset == '1' ? (
                                          <Stage2Final matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px', zIndex: 10 }} />
                                        ) : row?.stage === 'ST2' ? (
                                          <Stage2 matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px' }} />
                                        ) : null}
                                        {row?.timerStatus == 'Pause' && (
                                          <Box sx={{ marginLeft: '5px', display: 'flex', alignItems: 'center' }}>
                                            <PauseIcon width={20} height={20} />
                                          </Box>
                                        )}
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell
                                      sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '10px',
                                        color: '#666666',
                                        borderBottom: 'none !important',
                                      }}
                                    >
                                      Countdown Timer
                                    </TableCell>
                                    <TableCell
                                      sx={{ borderBottom: 'none !important' }}
                                    >
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                      >
                                        {/* <Grid sx={{width:"150px"}}> */}
                                        <QuickSwitchPropertyTimer
                                          isUnPublished={true}
                                          propertyId={row?.property?.propertyId}
                                          cardapi={listofcards}
                                          propertyData={row}
                                        />
                                        {/* </Grid> */}
                                      </Stack>
                                    </TableCell>
                                  </TableRow>
                                </>
                              )}
                            </TableBody>
                          </Table>
                        ) : (
                          <Table sx={{ width: '60vw' }}>
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: '10px',
                                    color: '#666666',
                                    alignItems: 'left',
                                  }}
                                >
                                  Status
                                </TableCell>
                                {!buyerregister && (
                                  <>
                                    <TableCell
                                      sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '10px',
                                        color: '#666666',
                                        alignItems: 'left',
                                      }}
                                    >
                                      Highest Offer
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '10px',
                                        color: '#666666',
                                        alignItems: 'left',
                                      }}
                                    >
                                      Stage
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '10px',
                                        color: '#666666',
                                        alignItems: 'left',
                                      }}
                                    >
                                      Countdown Timer
                                    </TableCell>
                                  </>
                                )}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              <TableRow
                                sx={{
                                  '&:last-child td, &:last-child th': {
                                    border: 0,
                                  },
                                  cursor: 'pointer',
                                }}
                              >
                                <TableCell align="left">
                                  <Box
                                    // variant="contained"
                                    // bgcolor={row.Status == "Online" ? "#10D35E" : "#F39800"}

                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      width: 'min-content',
                                      padding: '2px 20px',
                                      borderRadius: '3px',
                                      whiteSpace: 'nowrap',
                                      color: '#FFFFFF',
                                      background:
                                        row?.property?.status == 'Sold'
                                          ? '#F93939'
                                          : row?.property?.status == 'Unpublish'
                                          ? '#529aee'
                                          : row.campaignType === 'Online'
                                          ? '#10D35E'
                                          : '#F39800',
                                      textTransform: 'none',
                                      fontSize: '14px',
                                      fontWeight: buyerregister ? 300 : 400,
                                      fontFamily: 'poppins',
                                    }}
                                  >
                                    {' '}
                                    {row?.property?.status == 'Sold'
                                      ? row?.property?.status
                                      : row?.property?.status == 'Unpublish'
                                      ? 'Unpublished'
                                      : row?.campaignType}
                                  </Box>
                                </TableCell>
                                {!buyerregister && (
                                  <>
                                    <TableCell
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'left',
                                      }}
                                    >
                                      {/* Highest Offer */}
                                      {row.highestOffer &&
                                      row.highestOffer !== '0' ? (
                                        <Stack
                                          direction="row"
                                          alignItems="center"
                                          //  justifyContent="center"
                                          border={'none'}
                                          gap={1}
                                          //  width={"100%"}
                                          fontWeight={300}
                                          color={'#000000'}
                                          fontFamily={'poppins'}
                                          //  marginLeft={"-15px"}
                                          // marginLeft={
                                          //  row.propertyAddress.streetName.length < 10 ? 0 : 5
                                          // }
                                        >
                                          {/* <TableCell colSpan={5} style={{borderBottom:"0px"}}> */}
                                          {row.highestOffer}
                                          <CircleRounded
                                            // color={data.color}
                                            sx={{
                                              fontSize: '7px',
                                              marginBottom: '15px',
                                              color:
                                                row?.highestOfferIsConditional ==
                                                1
                                                  ? '#F93939'
                                                  : '#10D35E',
                                            }}
                                          />
                                          {/* </TableCell> */}
                                        </Stack>
                                      ) : (
                                        <Typography>-</Typography>
                                      )}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {row?.timerStatus === 'End' ? (
                                          <Ended matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px' }} />
                                        ) : row?.stage === 'ST1' ? (
                                          <Stage1 matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px' }} />
                                        ) : row?.stage === 'ST2' && row?.isReset == '1' ? (
                                          <Stage2Final matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px', zIndex: 10 }} />
                                        ) : row?.stage === 'ST2' ? (
                                          <Stage2 matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px' }} />
                                        ) : null}
                                        {row?.timerStatus == 'Pause' && (
                                          <Box sx={{ marginLeft: '5px', display: 'flex', alignItems: 'center' }}>
                                            <PauseIcon width={20} height={20} />
                                          </Box>
                                        )}
                                      </Box>
                                    </TableCell>
                                    <TableCell align="left">
                                      {/* Countdown Timer */}
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                      >
                                        <QuickSwitchPropertyTimer
                                          isUnPublished={true}
                                          propertyId={row?.property?.propertyId}
                                          cardapi={listofcards}
                                          propertyData={row}
                                        />
                                      </Stack>
                                    </TableCell>
                                  </>
                                )}
                              </TableRow>
                            </TableBody>
                          </Table>
                        ))}
                    </TableCell>
                    {isWindowbelow1200 ? (
                      expandedRows[row?.property?.propertyId] ? (
                        <KeyboardArrowUpIcon
                          onClick={() =>
                            handleRowToggle(row?.property?.propertyId)
                          }
                        />
                      ) : (
                        <KeyboardArrowDownIcon
                          onClick={() =>
                            handleRowToggle(row?.property?.propertyId)
                          }
                        />
                      )
                    ) : (
                      <>
                        <TableCell
                          align={buyerregister ? 'right' : 'left'}
                          sx={{
                            ...poppins400,
                            fontSize: '14px',
                            borderRadius: '5px',
                          }}
                        >
                          <Box
                            // variant="contained"
                            // bgcolor={row.Status == "Online" ? "#10D35E" : "#F39800"}

                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: 'min-content',
                              padding: '2px 20px',
                              borderRadius: '3px',
                              whiteSpace: 'nowrap',
                              color: '#FFFFFF',
                              background:
                                row?.property?.status == 'Sold'
                                  ? '#F93939'
                                  : row?.property?.status == 'Unpublish'
                                  ? '#529aee'
                                  : row.campaignType === 'Online'
                                  ? '#10D35E'
                                  : '#F39800',
                              textTransform: 'none',
                              fontSize: '14px',
                              fontWeight: buyerregister ? 300 : 400,
                              fontFamily: 'poppins',
                            }}
                          >
                            {' '}
                            {row?.property?.status == 'Sold'
                              ? row?.property?.status
                              : row?.property?.status == 'Unpublish'
                              ? 'Unpublished'
                              : row?.campaignType}
                          </Box>
                        </TableCell>

                        {!buyerregister && (
                          <>
                            <TableCell
                              sx={{
                                ...poppins300,
                              }}
                              align="center"
                            >
                              {row.highestOffer && row.highestOffer !== '0' ? (
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  justifyContent="center"
                                  border={'none'}
                                  gap={1}
                                  width={'100%'}
                                  fontWeight={300}
                                  color={'#000000'}
                                  fontFamily={'poppins'}
                                  // marginLeft={
                                  //  row.propertyAddress.streetName.length < 10 ? 0 : 5
                                  // }
                                >
                                  {/* <TableCell colSpan={5} style={{borderBottom:"0px"}}> */}
                                  {row.highestOffer}
                                  <CircleRounded
                                    // color={data.color}
                                    sx={{
                                      fontSize: '7px',
                                      marginBottom: '15px',
                                      color:
                                        row?.highestOfferIsConditional == 1
                                          ? '#F93939'
                                          : '#10D35E',
                                    }}
                                  />
                                  {/* </TableCell> */}
                                </Stack>
                              ) : (
                                <Typography>-</Typography>
                              )}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{
                                ...poppins600,
                                fontSize: '12px',
                                borderBottom: 'none',
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {row?.timerStatus === 'End' ? (
                                  <Ended matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px' }} />
                                ) : row?.stage === 'ST1' ? (
                                  <Stage1 matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px' }} />
                                ) : row?.stage === 'ST2' && row?.isReset == '1' ? (
                                  <Stage2Final matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px' }} />
                                ) : row?.stage === 'ST2' ? (
                                  <Stage2 matches450={true} customStyles={{ borderRadius: '2px', height: '20px', padding: '1px 12px' }} />
                                ) : null}
                                {row?.timerStatus == 'Pause' && (
                                  <Box sx={{ marginLeft: '5px', display: 'flex', alignItems: 'center' }}>
                                    <PauseIcon width={20} height={20} />
                                  </Box>
                                )}
                              </Box>
                            </TableCell>

                            <TableCell
                              align="right"
                              width={'163px'}
                              padding={0}
                            >
                              {/* {row.countdownTimer} */}
                              {/*  */}
                              <Stack margin={0}>
                                {/* <Grid sx={{width:"150px"}}> */}
                                <QuickSwitchPropertyTimer
                                  isUnPublished={true}
                                  propertyId={row?.property?.propertyId}
                                  cardapi={listofcards}
                                  propertyData={row}
                                />
                                {/* </Grid> */}
                              </Stack>
                            </TableCell>
                          </>
                        )}
                      </>
                    )}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '44vh',
            minWidth: '100%',
            whiteSpace: 'nowrap',
            marginLeft: isWindowbelow400 && '50px',
          }}
        >
          <Typography sx={{ fontSize: '18px', fontFamily: 'poppins' }}>
            No live active property available
          </Typography>
        </div>
      )}
    </>
  );
}
